<template>
	<div id="photovoltaicCarport">
		<Header :navbg='true'></Header>
		<div class="carport" v-if="carportInfo">
			<div class="spot-wrap">
				<iframe ref="iframe" :src="carportInfo.vr_url" frameborder="0"
					style="width: 100%;height: 100%;"></iframe>
			</div>
			<div class="content" v-html="carportInfo.description"></div>
		</div>
		<div class="business">
			<div class="lan-wrap" @click="show = true">
				<i>{{languagesList[index].name}}</i>
				<img class="lanImg" :src="languagesList[index].image" mode="widthFix"></img>
				<van-icon name="arrow-down" />
			</div>
			<van-action-sheet v-model="show" :actions="languagesList" @select="onSelect" :close-on-click-action="true"/>
		</div>
		<div class="btn-wrap">
			<van-button @click="gobuyTap(carportInfo.mall_url)" round color="#FFFFFF" plain>立即购买</van-button>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Header from '@/components/head2022'
	import Footer from '@/components/foot2022'
	import {
		mapState
	} from 'vuex'
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				languagesList: [],
				index: 0,
				carportInfo: null,
				show: false,
			}
		},
		computed: {
			...mapState(['houseApi']),
		},
		created() {
			this.getMultilingualList();
		},
		methods: {
			onSelect(item,index) {
				this.index=index;
				this.getSeriesDetail();
			},
			getMultilingualList: function() {
				this.$axios.get(this.houseApi + 'languages')
					.then(res => {
						this.languagesList = res.data.data;
						this.getSeriesDetail();
					})
			},
			getSeriesDetail: function() {
				this.$axios({
						method: 'get',
						url: this.houseApi + 'multilingue_product_pc_show',
						headers: {
							language: this.languagesList[this.index].code
						},
						params: {
							multilingue_tag: 1
						},
					})
					.then(res => {
						this.carportInfo = res.data;
					})
			},
			gobuyTap(url) {
				window.open(url);
			},
		},
	}
</script>
<style lang="scss">
	#photovoltaicCarport{
		.van-button--round {
			width: 232px;
			height: 32px;
			font-size: 12px;
			background: #222222;
			cursor: pointer;
		}
		
		.btn-wrap {
			width: 100%;
			display: flex;
			justify-content: center;
		}
		
		.carport {
			width: 100%;
		
			.spot-wrap {
				width: 100%;
				height: 100vh;
				background-size: 100% 100%;
				background-position: center center;
		
			}
		
			.content {
				max-width: 100%;
			}
		}
		.business {
			font-size: 18px;
			position: fixed;
			top: 10%;
			color: #000000;
			right: 12%;
			text-align: center;
			background-color: #FFFFFF;
			display: flex;
			padding: 5px 8px;
			align-items: center;
			justify-content: center;
			
			.lan-wrap {
				font-size: 12px;
				cursor: pointer;
				color: #409EFF;
		
				.lanImg {
					width: 18px;
					margin: 0 5px;
				}
			}
		}
	}
</style>